import { Call } from "@twilio/voice-sdk";

import { CALL_STATUS } from "@/constants/call";
import { CallState } from "@/features/telephony/types/call-state.types";

export const mapTwilioCallStateToDomain = (status: Call.State | undefined): CallState => {
    switch (status) {
        case "connecting":
            return CALL_STATUS.CONNECTING;
        case "open":
            return CALL_STATUS.IN_PROGRESS;
        case "ringing":
            return CALL_STATUS.RINGING;
        case "pending":
            return CALL_STATUS.QUEUED;
        case "reconnecting":
            return CALL_STATUS.CONNECTING;
        case "closed":
            return CALL_STATUS.DISCONNECTED;
        default:
            return CALL_STATUS.DISCONNECTED;
    }
};

export const mapTwilioDisconnectStatusToDomain = (status: Call.State | undefined): CallState => {
    const statusStr = String(status);
    if (statusStr === "busy") {
        return CALL_STATUS.BUSY;
    }
    if (statusStr === "no-answer") {
        return CALL_STATUS.NO_ANSWER;
    }
    if (statusStr === "failed") {
        return CALL_STATUS.FAILED;
    }

    return mapTwilioCallStateToDomain(status);
};
